import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React from 'react';

function EsimSupportingDevices() {
  const handleOpenLink = () => {
    const newTab = window.open('https://www.esim.com.au/blog/eSIM-supporting-phones', '_blank');
    if (!newTab) {
      alert('Please allow pop-ups to open the link.');
    }
  };

  return (
    <DashboardLayout> 
      <DashboardNavbar />
      <div className="formbold-main-wrapper">
                    <div className="formbold-form-wrapper">
      <div style={styles.container}>
        <p style={styles.text}>Click the button below to view the eSIM supported devices page:</p>
        <button style={styles.button} onClick={handleOpenLink}>
          Open Page
        </button>
      </div>
      </div>
      </div>
    </DashboardLayout> 
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto', 
    textAlign: 'center',
  },
  text: {
    marginBottom: '20px',
    fontSize: '18px',
    color: '#344767',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    color: '#fff',
    backgroundColor: '#e20e75',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
  },
  buttonHover: {
    backgroundColor: '#0056b3',
  },
};

export default EsimSupportingDevices;
